import React, { FC, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Card } from 'components/Card'
import { Heading } from 'components/Heading'
import { Text } from 'components/Text'
import { Stack } from 'components/Stack'
import { Checkbox } from 'components/Checkbox'
import { Button } from 'components/Button'
import { Alert } from 'components/Alert'

export type EmailNotificationsFields = {
  company_news: boolean
  accepted_invitations: boolean
}

type EmailNotificationsFormProps = {
  onSubmit: (body: EmailNotificationsFields) => Promise<void>
}

export const EmailNotificationsForm: FC<EmailNotificationsFormProps> = (props) => {
  const { t } = useTranslation()
  const [error, setError] = useState(false)
  const [success, setSuccess] = useState(false)
  const [loading, setLoading] = useState(false)
  const [form, setFormFields] = useState<EmailNotificationsFields>({
    company_news: false,
    accepted_invitations: false,
  })

  const onSubmit = (event: React.FormEvent) => {
    event.preventDefault()
    setLoading(true)
    setError(false)
    setSuccess(false)

    props
      .onSubmit(form)
      .then(() => {
        setSuccess(true)
      })
      .catch(() => {
        setError(true)
      })
      .finally(() => {
        setLoading(false)
      })
  }

  const onFieldChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setFormFields({ ...form, [event.target.name]: event.target.checked })
  }

  return (
    <div>
      <Card>
        <Stack>
          <Stack space="small">
            <Heading size="card">{t('account.notifications.heading')}</Heading>
            <Text>{t('account.notifications.subtitle')}</Text>
          </Stack>
          <form onSubmit={onSubmit}>
            <Stack space="medium">
              <Checkbox
                name="system_alerts"
                label={t('account.notifications.form.system_alerts')}
                checked={true}
                onChange={() => null}
                disabled
              />
              <Checkbox
                name="company_news"
                label={t('account.notifications.form.company_news')}
                checked={form.company_news}
                onChange={onFieldChange}
              />
              <Checkbox
                name="accepted_invitations"
                label={t('account.notifications.form.accepted_invitations')}
                checked={form.accepted_invitations}
                onChange={onFieldChange}
              />

              <Button type="submit" loading={loading}>
                {t('account.notifications.form.cta')}
              </Button>
              {error && (
                <Alert tone="critical" full>
                  {t('common.messages.error')}
                </Alert>
              )}
              {success && (
                <Alert tone="positive" full>
                  {t('common.messages.success')}
                </Alert>
              )}
            </Stack>
          </form>
        </Stack>
      </Card>
    </div>
  )
}

EmailNotificationsForm.displayName = 'EmailNotificationsForm'
